export const TIMELINE_FALLBACK = [
  {
    id: "tl-1",
    year: "2025",
    month: "May",
    title: "Joined Superwider",
    description:
      "Working part-time as a full-stack developer with Next.js and TypeScript.",
    image: null,
  },
  {
    id: "tl-2",
    year: "2025",
    month: "Feb",
    title: "ECIU Hackathon",
    description:
      "Built OLA — an AI agent using ChatGPT to guide students through ECIU opportunities.",
    image: null,
  },
  {
    id: "tl-3",
    year: "2025",
    month: "Jan",
    title: "MSc Thesis: MetaPriv",
    description:
      "Started building a cross-platform privacy tool for Facebook under Prof. Antonios Michalas.",
    image: null,
  },
  {
    id: "tl-4",
    year: "2024",
    month: "Sep",
    title: "ibtehaz.xyz Revamp",
    description:
      "Began rebuilding this portfolio from scratch — a personal playground and creative space.",
    image: null,
  },
  {
    id: "tl-5",
    year: "2024",
    month: "Jul",
    title: "OASIS Research Assistant",
    description:
      "Joined OASIS lab, co-authored a conference paper, contributed to ongoing journal research.",
    image: null,
  },
  {
    id: "tl-6",
    year: "2024",
    month: "Feb",
    title: "ECIU Challenge, Lithuania",
    description:
      "Hands-on energy sector project with KTU and LitGrid spanning four months.",
    image: null,
  },
  {
    id: "tl-7",
    year: "2023",
    month: "Jun",
    title: "HUBS Summer Internship",
    description:
      "Explored entrepreneurship, innovation sprints, and startup culture.",
    image: null,
  },
  {
    id: "tl-8",
    year: "2022",
    month: "Sep",
    title: "MSc at Tampere University",
    description:
      "Began MSc in Information Security with a minor in Human-Technology Interaction.",
    image: null,
  },
];
